import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'

import css from './Dashboard.css'

const ConnectedToPractice = ({ handleDisconnect, name }) => (
  <div className={css.connectedPracticeIndicator}>
    <span>Connected to {name}</span>
    <Button
      className={css.disconnectButton}
      onClick={handleDisconnect}
    >
      Disconnect
    </Button>
  </div>
)

ConnectedToPractice.propTypes = {
  name: PropTypes.string.isRequired,
  handleDisconnect: PropTypes.func.isRequired,
}

export default ConnectedToPractice



// WEBPACK FOOTER //
// ./src/Dashboard/ConnectedToPractice.js